import { MenuOption, MenuItem } from '../types';
import { MenuOptionGroupFields_editorConfig } from '../__generated__/MenuOptionGroupFields';

export enum Sorter {
  Mixers = 'mixer',
}

export type MenuOptionSorter = (a: MenuOption, b: MenuOption) => -1 | 0 | 1;

export type OptionConfig = MenuOptionGroupFields_editorConfig;

export interface FormMenuItem extends Omit<MenuItem, 'price'> {
  price: string;
}
